/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var WeightHangingIcon = createIcon({
  name: 'WeightHangingIcon',
  height: 512,
  width: 512,
  svgPath: 'M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default WeightHangingIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/weight-hanging-icon.js
// module id = 1102
// module chunks = 0